import { render } from "./BaseTableProjectManagementAnswers.vue?vue&type=template&id=1d7c38e8&scoped=true"
import script from "./BaseTableProjectManagementAnswers.vue?vue&type=script&lang=js"
export * from "./BaseTableProjectManagementAnswers.vue?vue&type=script&lang=js"

import "./BaseTableProjectManagementAnswers.vue?vue&type=style&index=0&id=1d7c38e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7c38e8"]])

export default __exports__